import apiV2 from '.'

export const emotionsApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    createUserEmotion: builder.mutation({
      query: ({ domainId, eventId, emotionId, sequenceId }) => ({
        url: `/domains/${domainId}/events/${eventId}/emotions/users`,
        method: 'POST',
        body: { emotionId, sequenceId },
      }),
    }),
    getEmotions: builder.query({
      query: ({ domainId, eventId }) => ({ url: `/domains/${domainId}/events/${eventId}/emotions` }),
      transformResponse: response => response.data.emotions,
    }),
    getUserEmotions: builder.query({
      query: ({ domainId, eventId, sequenceId }) => ({
        url: `/domains/${domainId}/events/${eventId}/emotions/sequences/${sequenceId}/users`,
      }),
      transformResponse: response => response.data.emotions,
    }),
  }),
})

export const { useCreateUserEmotionMutation, useGetEmotionsQuery, useLazyGetUserEmotionsQuery } = emotionsApi
